import React from 'react';
import { connect } from 'react-redux';

import { useSubmit } from 'hooks';
import SettingsActions from 'store/reducers/Settings';
import AccountService from 'api/Account';
import VerifyPhoneView from './view';

const VerifyPhone = React.memo( ( {
  entityId, open, onClose, onReload, toggleLoading, toggleInfoAlert,
} ) => {
  const submitForm = useSubmit( {
    promise: ( dataToSend ) => AccountService.verifyPhoneCode( entityId, dataToSend ),
    toggleLoading,
    toggleInfoAlert,
    callback: onReload,
  } );

  return (
    <VerifyPhoneView
      open={open}
      onClose={onClose}
      onSubmit={submitForm}
    />
  );
} );

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( VerifyPhone );
